// Re-exportar os schemas específicos
export * from "./schemas";

// Manter compatibilidade com o tipo antigo
export type TProductFormData = 
  | import("./schemas").TPersonalAccidentFormData
  | import("./schemas").TGroupLifeFormData
  | import("./schemas").TAssistanceFormData
  | import("./schemas").TSoulhubAssistanceInsuranceFormData
  | import("./schemas").TAutoFormData
  | import("./schemas").TCreditProductFormData
  | import("./schemas").TWarrantyInsuranceFormData
  | import("./schemas").TTheftInsuranceFormData;

// Schema para validação de clientId
export const clientIdSchema = z.object({
  clientId: z.string().uuid({ message: "ID do cliente é obrigatório" }),
});

import { z } from "zod";